import React from "react";
import { withStyles } from '@material-ui/styles';
import { compose } from 'redux';

import withShowModal from "../../hocs/with_show_modal.js";
import { RawModalContainer } from "../../base/modals/modal_container.js";

import { EditParticipantType, CreateParticipantType, InviteMemberType } from "./constants.js";
import EditInvestment from "./edit_investment.js";
import CreateInvestment from "./create_investment.js";
import InviteMember from "./invite_member.js";

const styles = theme => ({
  root: {
  },
});

class Container extends RawModalContainer {


  static getDerivedStateFromProps(props, state) {
    const { modalShowed, modalInfo } = props;

    return {
      modalInfo: modalInfo,
      modalShowed: modalShowed
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return JSON.stringify(this.state.modalShowed) !== JSON.stringify(nextState.modalShowed) ||
           JSON.stringify(this.state.modalInfo) !== JSON.stringify(nextState.modalInfo);
  }

  modalByType() {
    let modal = super.modalByType();
    if(modal) {
      return modal;
    }
    const { type, modalContext } = this.props;
    const { hideModal, onModalHidden } = modalContext;

    const { modalShowed, modalInfo } = this.state;
    
    if(type === EditParticipantType) {
      return <EditInvestment open = { modalShowed }
                              close = { hideModal }
                              onClose = { onModalHidden }
                              { ...modalInfo }/>
    }
    if(type === CreateParticipantType) {
      return <CreateInvestment open = { modalShowed }
                              close = { hideModal }
                              onClose = { onModalHidden }
                              { ...modalInfo }/>
    }
    if(type === InviteMemberType) {
      return <InviteMember open = { modalShowed }
                           close = { hideModal }
                           onClose = { onModalHidden }
                           { ...modalInfo }/>
    }

    return undefined;
  }

}

export default compose(withShowModal, withStyles(styles))(Container);
